import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, itemName, language }) => {
  if (!isOpen) return null;

  const labels = {
    title: { en: 'Confirm Delete', ar: 'تأكيد الحذف' },
    message: { en: `Are you sure you want to delete "${itemName}"? This action cannot be undone.`, ar: `هل أنت متأكد من حذف "${itemName}"؟ لا يمكن التراجع عن هذا الإجراء.` },
    cancel: { en: 'Cancel', ar: 'إلغاء' },
    delete: { en: 'Delete', ar: 'حذف' }
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-card rounded-xl shadow-elevation-4 border border-border w-full max-w-md">
        <div className="border-b border-border px-6 py-4 flex items-center justify-between">
          <h2 className="text-xl font-semibold text-foreground">
            {labels?.title?.[language]}
          </h2>
          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-muted transition-smooth"
            aria-label="Close"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <div className="p-6">
          <div className="flex items-start gap-4 mb-6">
            <div className="p-3 rounded-full bg-error/10">
              <Icon name="AlertTriangle" size={24} className="text-error" />
            </div>
            <p className="text-base text-foreground flex-1">
              {labels?.message?.[language]}
            </p>
          </div>

          <div className="flex gap-3">
            <Button
              variant="outline"
              fullWidth
              onClick={onClose}
            >
              {labels?.cancel?.[language]}
            </Button>
            <Button
              variant="destructive"
              fullWidth
              onClick={onConfirm}
            >
              {labels?.delete?.[language]}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;